(() => {
  const SECTION_HANDLE = "search-counts";

  const isSearchPage = () =>
    document.querySelector(
      ".shopify-section--main-search, form.main-search-form",
    ) !== null;

  if (!isSearchPage()) return;

  const getParams = () => new URL(window.location.href).searchParams;
  const getTerms = () => (getParams().get("q") || "").trim();
  const getType = () => (getParams().get("type") || "").trim();

  const needsTypeRedirect = () => {
    const terms = getTerms();
    if (!terms) return false;

    const type = getType();
    return !type || type.includes(",");
  };

  const redirectToType = (type) => {
    const url = new URL(window.location.href);
    url.searchParams.set("type", type);
    url.searchParams.delete("page");
    window.location.replace(url.toString());
  };

  const getKey = (type, terms) => `sc_search_counts:v2:${type}:${terms}`;

  const fetchCount = async (type, terms) => {
    const key = getKey(type, terms);
    const cached = sessionStorage.getItem(key);
    if (cached !== null) return Number(cached);

    const searchUrl = window.Shopify?.routes?.root
      ? `${window.Shopify.routes.root}search`
      : "/search";

    const url =
      `${searchUrl}?q=${encodeURIComponent(terms)}` +
      `&type=${encodeURIComponent(type)}` +
      `&sections=${SECTION_HANDLE}`;

    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) return 0;

    const json = await res.json();
    const html = json[SECTION_HANDLE] || "";
    const doc = new DOMParser().parseFromString(html, "text/html");
    const el = doc.querySelector("[data-search-counts]");
    const count = el ? Number(el.getAttribute("data-count") || 0) : 0;

    sessionStorage.setItem(key, String(count));
    return count;
  };

  const setCount = (name, value) => {
    document.querySelectorAll(`[data-count="${name}"]`).forEach((el) => {
      el.textContent = String(value);
    });
  };

  const update = async () => {
    const terms = getTerms();
    if (!terms) return;

    const [p, a, pg] = await Promise.all([
      fetchCount("product", terms),
      fetchCount("article", terms),
      fetchCount("page", terms),
    ]);

    setCount("product", p);
    setCount("article", a);
    setCount("page", pg);

    return { product: p, article: a, page: pg };
  };

  // Fetch counts first, then redirect to the first type with results
  if (needsTypeRedirect()) {
    update()
      .then((counts) => {
        if (!counts) return;
        if (counts.product > 0) return redirectToType("product");
        if (counts.article > 0) return redirectToType("article");
        if (counts.page > 0) return redirectToType("page");
        redirectToType("product");
      })
      .catch(() => redirectToType("product"));
    return;
  }

  // initial
  update().catch(() => {});

  // rerun after AJAX DOM replacements (pagination/filters)
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (
          n.matches?.(".collection__results, .search-type-filter") ||
          n.querySelector?.(".search-type-filter")
        ) {
          update().catch(() => {});
          return;
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // if theme updates URL via pushState
  const _pushState = history.pushState;
  history.pushState = function () {
    _pushState.apply(this, arguments);
    setTimeout(() => update().catch(() => {}), 0);
  };
  window.addEventListener("popstate", () => update().catch(() => {}));
})();
